// extracted by mini-css-extract-plugin
module.exports = {"emote":"_1_ADz","not-official":"_33mFf","notOfficial":"_33mFf","title":"_5e4yR","emote-pixel":"CTL6P","emotePixel":"CTL6P"};